export const trackingEvents = {
  PAGE: {
    VIEWED: 'worker_blocks.page.viewed',
  },
  EDIT: {
    CLICKED: 'worker_blocks.edit.clicked',
  },
}
